// extracted by mini-css-extract-plugin
module.exports = {"text":"favorites_text__xfxBW","readOnlyBtn":"favorites_readOnlyBtn__acNhf"};